module.exports = __webpack_public_path__ + "img/group-volunteer-opportunities.6b8c008b.jpg";